import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid'
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Build } from '@material-ui/icons';
import { handleOpenDestinationEditDialog } from '../../../reducers/uiSlice';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '600px'
    }
}))

const data = [
    {
        id: 1231,
        order_sn: "123123123",
        address: "123 1244kjasdk",
        lat: "48.65411",
        lng: "-123.32651"
    }
]

function ProblematicOrderList(props){
    let {orderList} = props
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();

    const columns = [
        {field: 'order_sn', headerName: t('SN'), flex: 1},
        {field: 'address', headerName: t('address'), flex: 1},
        {field: 'lat', headerName: t('lat'), flex: 1},
        {field: 'lng', headerName: t('lng')},
        {
            field: 'action',
            headerName: t('action'), 
            disableClickEventBubbling: true, 
            renderCell: (params)=> {
                return (
                    <Button
                        variant="contained"
                        color='secondary'
                        startIcon={<Build/>}
                        onClick={()=>{dispatch(handleOpenDestinationEditDialog({open: true, order: params.row}))}}
                    >FIX</Button>
                )
            }
        }
    ]

    return (
        <div className={classes.root}>
            <DataGrid
                columns={columns}
                rows={data}
                disableColumnFilter
                disableColumnMenu
                disableColumnSelector
                disableSelectionOnClick
            />
        </div>
    )
}


export default ProblematicOrderList